import { createContext } from 'react';
import { CommunicationCounts } from '../services/communicationService';

export interface CommunicationCountsContextValue {
  /** Null until the first successful fetch (or when the caller isn't eligible to poll). */
  counts: CommunicationCounts | null;
  /** Force an immediate refresh — call after a booking/message action so the badge updates now. */
  refresh: () => Promise<void>;
}

export const CommunicationCountsContext = createContext<CommunicationCountsContextValue | null>(null);
